import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, useParams } from 'react-router-dom';

import { CartDrawerProvider } from '@lib/context/cart-drawer-context';
import { mainLayoutQueryOptions } from '@lib/query/options/layout';
import { LayoutConfirmModalProvider } from '@modules/account/components/confirm-modal';
import { CartDrawer } from '@modules/layout/components/cart-drawer';
import { MobileNavProvider } from '@modules/layout/components/mobile-nav';
import { MobileSearchProvider } from '@modules/layout/components/mobile-search';
import Nav from '@modules/layout/templates/nav';
import Footer from '@modules/layout/templates/footer';

/**
 * Main layout - mirrors Next.js (main) route group layout
 * Includes header (Nav), main content area, and Footer
 */
export default function MainLayout() {
  const { countryCode = 'tw' } = useParams<{ countryCode: string }>();

  // Fetch layout data for ConfirmModal provider
  // useSuspenseQuery guarantees data is available before children render,
  // so child pages can safely read layout cache without null guards.
  const { data } = useSuspenseQuery(mainLayoutQueryOptions(countryCode));
  const customer = data.customer;
  const isLoggedIn = data.isLoggedIn;
  const isActive = data.isActive;

  return (
    <CartDrawerProvider isLoggedIn={isLoggedIn}>
      <LayoutConfirmModalProvider
        customer={customer}
        isActive={isActive}
        priceChangedContent={null} // TODO: Add CMS price changed content
      >
        <MobileNavProvider>
          <MobileSearchProvider>
            <Nav />
            {/* 405px = 180px (header) + 225px (footer) - same as Next.js */}
            <main className="mb-8 min-h-[calc(100vh-405px)]">
              <Outlet />
            </main>
            <Footer />
            {/* Cart Drawer - rendered at layout level for portal positioning */}
            <CartDrawer />
          </MobileSearchProvider>
        </MobileNavProvider>
      </LayoutConfirmModalProvider>
    </CartDrawerProvider>
  );
}
